<template>
  <div>
    <value-or-variable v-model='value' type='string' :variables='[]' @change='onChange'>
      <template #default=''>
        <events-selector v-model='value' :events-list='eventsList' />
      </template>
    </value-or-variable>
  </div>
</template>

<script>
import EventsSelector from '@ui/atoms/EventsSelector.vue';
import ValueOrVariable from '@ui/molecules/ValueOrVariable.vue';
import { abstractField } from "vue-form-generator";
import Searcher from '@edit/tree/searcher.js';
export default {
  mixins: [ abstractField ],
  data() {
    let initialValue = this.value;
    if (!initialValue && this.schema.default) {
      initialValue = this.schema.default;
    }
    if (initialValue !== this.value) {
      this.$set(this, 'value', initialValue);
    }

    const searcher = new Searcher(this.vfg.schema.data.partutil.gamedata);
    const eventsList = searcher.findEvents();
    return {
      eventsList
    }
  },
  components:{
    ValueOrVariable,
    EventsSelector
  },
  methods: {
    onChange({nv,ov}) {
      this.$emit("change", {nv,ov});
    }
  },
  computed:{
  },
}
</script>

